import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * Regla de la tolerancia propia de un horario, la misma del kiosco
 * (horario_editor_screen.dart) y del servidor (HorarioLaboralBuss): un
 * entero de 0 a 240 minutos, o vacío para usar la de Parámetros de
 * asistencia. Vive aparte del componente para poder probarla sin montar
 * el formulario.
 */
export const TOLERANCIA_MAXIMA_MINUTOS = 240;

export const MENSAJE_TOLERANCIA_INVALIDA =
  "La tolerancia debe ser un entero de 0 a 240 minutos.";

/** Vacío es válido: significa "usa la de Parámetros". */
function estaVacia(valor: unknown): boolean {
  return valor === null || valor === undefined || `${valor}`.trim() === "";
}

export function toleranciaValida(valor: unknown): boolean {
  if (estaVacia(valor)) {
    return true;
  }
  const minutos = Number(valor);
  return Number.isInteger(minutos) && minutos >= 0 && minutos <= TOLERANCIA_MAXIMA_MINUTOS;
}

/** Validador reactivo; el error se llama `tolerancia`. */
export const toleranciaValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null =>
  toleranciaValida(control.value) ? null : { tolerancia: true };

/**
 * Lo que viaja al servidor. Vacío se manda como null EXPLÍCITO, no se
 * omite: el UPDATE escribe la columna con lo que llegue, y es la única
 * forma de volver a "usa la de Parámetros".
 */
export function toleranciaParaApi(valor: unknown): number | null {
  return estaVacia(valor) ? null : Number(valor);
}

/** Cómo se lee en el catálogo. */
export function etiquetaTolerancia(minutos: number | null | undefined): string {
  return minutos === null || minutos === undefined ? "La de Parámetros" : `${minutos} min`;
}
